module.exports = __webpack_public_path__ + "img/111.9a1bdf07.jpg";